import { render, staticRenderFns } from "./DialogEditIdeaTemplate.vue?vue&type=template&id=361d11cd"
import script from "./DialogEditIdeaTemplate.vue?vue&type=script&lang=js"
export * from "./DialogEditIdeaTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports